import '../internals/typed-array-constructor.js';
import { t as typedArrayConstructor } from '../../../../../../_virtual/typed-array-constructor.js';

var createTypedArrayConstructor = typedArrayConstructor.exports; // `Int8Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects

createTypedArrayConstructor('Int8', function (init) {
  return function Int8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});
